<!-- class="ss" is a static attribute on purpose: ng-select reads its host
     `class` and copies it onto the body-appended panel, which is the only
     hook that lets the option styles below stay scoped to this component.

     ariaLabel is cast because ng-select types it as `string` but binds it
     with [attr.aria-label], where undefined removes the attribute — exactly
     what is wanted when a linked <label> names the control instead. -->
<ng-select
    class="ss"
    [items]="items"
    bindValue="value"
    bindLabel="label"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [clearable]="clearable"
    [searchable]="true"
    [searchFn]="search"
    [placeholder]="placeholder"
    [notFoundText]="notFoundText"
    [ariaLabel]="$any(ariaLabel)"
    [labelForId]="labelForId"
    [ngModel]="value"
    [disabled]="disabled"
    (ngModelChange)="onModelChange($event)"
    (blur)="onBlur()"
    appendTo="body">

    <!-- Once chosen: one line, so a multi-select with many chips does not grow
         the control unboundedly. -->
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ss-tag">
            @if (item.flagged) { <i class="fas fa-triangle-exclamation ss-tag__flag"></i> }
            {{ item.label }}
            @if (multiple) {
                <span class="ss-tag__x" [attr.aria-label]="'Remove ' + item.label"
                      (click)="clear(item)">×</span>
            }
        </span>
    </ng-template>

    <!-- In the list: name on top, the details that tell two similar rows
         apart underneath. -->
    <ng-template ng-option-tmp let-item="item">
        <div class="ss-opt" [class.ss-opt--flagged]="item.flagged">
            <div class="ss-opt__main">
                <span class="ss-opt__label">{{ item.label }}</span>
                @if (item.hint) { <span class="ss-opt__hint">{{ item.hint }}</span> }
            </div>
            @if (item.badge) { <span class="ss-opt__badge">{{ item.badge }}</span> }
            @if (item.flagged) {
                <i class="fas fa-triangle-exclamation ss-opt__flag"
                   [title]="item.flagNote || 'No longer current'"></i>
            }
        </div>
    </ng-template>
</ng-select>
